import { Factory } from 'miragejs';

export default Factory.extend({
  name: (i) => (i % 2 ? 'SF' : 'NY'),
});
